export enum DataTypeDefXsd {
  AnyURI = 'xs:anyURI',
  Base64Binary = 'xs:base64Binary',
  Boolean = 'xs:boolean',
  Byte = 'xs:byte',
  Date = 'xs:date',
  DateTime = 'xs:dateTime',
  Decimal = 'xs:decimal',
  Double = 'xs:double',
  Duration = 'xs:duration',
  Float = 'xs:float',
  GDay = 'xs:gDay',
  GMonth = 'xs:gMonth',
  GMonthDay = 'xs:gMonthDay',
  GYear = 'xs:gYear',
  GYearMonth = 'xs:gYearMonth',
  HexBinary = 'xs:hexBinary',
  Int = 'xs:int',
  Integer = 'xs:integer',
  Long = 'xs:long',
  NegativeInteger = 'xs:negativeInteger',
  NonNegativeInteger = 'xs:nonNegativeInteger',
  NonPositiveInteger = 'xs:nonPositiveInteger',
  PositiveInteger = 'xs:positiveInteger',
  Short = 'xs:short',
  String = 'xs:string',
  Time = 'xs:time',
  UnsignedByte = 'xs:unsignedByte',
  UnsignedInt = 'xs:unsignedInt',
  UnsignedLong = 'xs:unsignedLong',
  UnsignedShort = 'xs:unsignedShort',
}
